/**
 * @desc: - 选择投注mode
 * @param  {[STRING]} value:        [当前选中值]
 * @param  {[FUNCTION]} onChange:   [点击变更值]
 * @author: ammo
 */
export default class SelectTimes extends React.Component {

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleOnchange = this.handleOnchange.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.handleOnFocus = this.handleOnFocus.bind(this);
    this.handleSelectEasy = this.handleSelectEasy.bind(this);
    this.state = {
      inputfocus: false
    }
  }

  // 输入变更
  handleOnchange() {
    const { onChange } = this.props;
    let times = ReactDOM.findDOMNode(this.refs.inputValue).value.replace(/[^0-9]/g,"").substring(0,5);
    if (times < 1) {
      if(times == ""){
        return false;
      }
      times = 1;
    }
    ReactDOM.findDOMNode(this.refs.inputValue).value = times;
    onChange(times)
  }

  // 点击变更
  handleClick(type) {
    let result = ReactDOM.findDOMNode(this.refs.inputValue).value;
    if (type == '-' && result == 1) {
      return;
    }
    if (type == '-') {
      result--;
    }
    if (type == '+') {
      result++;
    }
    ReactDOM.findDOMNode(this.refs.inputValue).value = result;
    this.handleOnchange()
  }

  // 失去焦点
  handleOnBlur() {
    const { onChange } = this.props;
    let times = ReactDOM.findDOMNode(this.refs.inputValue).value.replace(/[^0-9]/g,"").substring(0,5);
    if(times==""){
      times = 1
    }
    ReactDOM.findDOMNode(this.refs.inputValue).value = times
    onChange(times)
    _.delay(function(){
      this.setState({
        inputfocus: false
      })
    }.bind(this), 150)
    
  }
  // 获得焦点
  handleOnFocus() {
    this.setState({
      inputfocus: true
    })
  }

  // 选择下拉{text}数
  handleSelectEasy(num) {
    ReactDOM.findDOMNode(this.refs.inputValue).value = num;
    this.handleOnchange()
  }

  render() {
    const { value, text, display } = this.props;
    return (
      <div className='select-times' key={display}>
        <div className="multipleCon fl relative">
          <span onClick={this.handleClick.bind(this, '-')} className="reduce">-</span>
          <input className='input' maxLength="5" type="number" ref='inputValue' onChange={this.handleOnchange} onBlur={this.handleOnBlur} defaultValue={value||1}  onFocus={this.handleOnFocus}></input>
          <span onClick={this.handleClick.bind(this, '+')} className="add">+</span>
          {
            text && <span className="bei fr">{text}</span>
          }
          {
            this.state.inputfocus ?
              <ul className="downselect">
                <li onClick={this.handleSelectEasy.bind(this, 1)}>1{text}</li>
                <li onClick={this.handleSelectEasy.bind(this, 5)}>5{text}</li>
                <li onClick={this.handleSelectEasy.bind(this, 10)}>10{text}</li>
                <li onClick={this.handleSelectEasy.bind(this, 100)}>100{text}</li>
              </ul> : ''
          }
        </div>
      </div>
    );
  }
}
